"use strict";
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.OrdersLabel = exports.OrderSummaryMinDstAmountOutLabel = exports.OrderSummaryTradeIntervalLabel = exports.OrderSummaryTotalChunksLabel = exports.OrderSummaryChunkSizeLabel = exports.OrderSummaryOrderTypeLabel = exports.OrderSummaryDeadlineLabel = exports.TradeIntervalLabel = exports.MaxDurationLabel = exports.LimitPriceLabel = exports.CurrentMarketPriceLabel = exports.TotalTradesLabel = exports.ChunksAmountLabel = void 0;
var jsx_runtime_1 = require("react/jsx-runtime");
var __1 = require("..");
var context_1 = require("../context");
var store_1 = require("../store");
var styles_1 = require("../styles");
var base_1 = require("./base");
var AiOutlineHistory_1 = require("@react-icons/all-files/ai/AiOutlineHistory");
function ChunksAmountLabel() {
    var translations = (0, context_1.useTwapContext)().translations;
    return (0, jsx_runtime_1.jsxs)(base_1.Label, __assign({ tooltipText: translations.tradeSizeTooltip }, { children: [translations.tradeSize, " "] }));
}
exports.ChunksAmountLabel = ChunksAmountLabel;
var TotalTradesLabel = function () {
    var translations = (0, context_1.useTwapContext)().translations;
    return (0, jsx_runtime_1.jsx)(base_1.Label, __assign({ tooltipText: translations.totalTradesTooltip }, { children: translations.totalTrades }));
};
exports.TotalTradesLabel = TotalTradesLabel;
var CurrentMarketPriceLabel = function () {
    var translations = (0, context_1.useTwapContext)().translations;
    return (0, jsx_runtime_1.jsx)(base_1.Label, { children: translations.currentMarketPrice });
};
exports.CurrentMarketPriceLabel = CurrentMarketPriceLabel;
var LimitPriceLabel = function (_a) {
    var custom = _a.custom;
    var translations = (0, context_1.useTwapContext)().translations;
    var isLimitOrder = (0, store_1.useTwapStore)(function (store) { return store.isLimitOrder; });
    return ((0, jsx_runtime_1.jsxs)(__1.Styles.StyledRowFlex, __assign({ justifyContent: "flex-start", style: { width: "auto", position: "relative" }, gap: 3 }, { children: [(0, jsx_runtime_1.jsx)(base_1.Label, __assign({ tooltipText: isLimitOrder ? translations.limitPriceTooltip : translations.marketPriceTooltip }, { children: custom || translations.limitPrice })), " "] })));
};
exports.LimitPriceLabel = LimitPriceLabel;
var MaxDurationLabel = function () {
    var translations = (0, context_1.useTwapContext)().translations;
    return (0, jsx_runtime_1.jsx)(base_1.Label, __assign({ tooltipText: translations.maxDurationTooltip }, { children: translations.maxDuration }));
};
exports.MaxDurationLabel = MaxDurationLabel;
var TradeIntervalLabel = function () {
    var translations = (0, context_1.useTwapContext)().translations;
    var getMinimumDelayMinutes = (0, store_1.useTwapStore)(function (store) { return store.getMinimumDelayMinutes(); });
    return (0, jsx_runtime_1.jsx)(base_1.Label, __assign({ tooltipText: (0, store_1.handleFillDelayText)(translations.tradeIntervalTootlip, getMinimumDelayMinutes) }, { children: translations.tradeInterval }));
};
exports.TradeIntervalLabel = TradeIntervalLabel;
var OrderSummaryDeadlineLabel = function (_a) {
    var subtitle = _a.subtitle;
    var translations = (0, context_1.useTwapContext)().translations;
    return ((0, jsx_runtime_1.jsx)(base_1.Label, __assign({ subtitle: subtitle, tooltipText: translations.confirmationDeadlineTooltip }, { children: translations.expiration })));
};
exports.OrderSummaryDeadlineLabel = OrderSummaryDeadlineLabel;
var OrderSummaryOrderTypeLabel = function (_a) {
    var subtitle = _a.subtitle;
    var translations = (0, context_1.useTwapContext)().translations;
    return ((0, jsx_runtime_1.jsx)(base_1.Label, __assign({ subtitle: subtitle, tooltipText: translations.confirmationOrderType }, { children: translations.orderType })));
};
exports.OrderSummaryOrderTypeLabel = OrderSummaryOrderTypeLabel;
var OrderSummaryChunkSizeLabel = function (_a) {
    var subtitle = _a.subtitle;
    var translations = (0, context_1.useTwapContext)().translations;
    return ((0, jsx_runtime_1.jsx)(base_1.Label, __assign({ subtitle: subtitle, tooltipText: translations.confirmationTradeSizeTooltip }, { children: translations.tradeSize })));
};
exports.OrderSummaryChunkSizeLabel = OrderSummaryChunkSizeLabel;
var OrderSummaryTotalChunksLabel = function (_a) {
    var subtitle = _a.subtitle;
    var translations = (0, context_1.useTwapContext)().translations;
    return ((0, jsx_runtime_1.jsx)(base_1.Label, __assign({ subtitle: subtitle, tooltipText: translations.confirmationTotalTradesTooltip }, { children: translations.totalTrades })));
};
exports.OrderSummaryTotalChunksLabel = OrderSummaryTotalChunksLabel;
var OrderSummaryTradeIntervalLabel = function (_a) {
    var subtitle = _a.subtitle;
    var translations = (0, context_1.useTwapContext)().translations;
    return ((0, jsx_runtime_1.jsx)(base_1.Label, __assign({ subtitle: subtitle, tooltipText: translations.confirmationtradeIntervalTooltip }, { children: translations.tradeInterval })));
};
exports.OrderSummaryTradeIntervalLabel = OrderSummaryTradeIntervalLabel;
var OrderSummaryMinDstAmountOutLabel = function (_a) {
    var subtitle = _a.subtitle;
    var translations = (0, context_1.useTwapContext)().translations;
    var isLimitOrder = (0, store_1.useTwapStore)(function (store) { return store.isLimitOrder; });
    return ((0, jsx_runtime_1.jsx)(base_1.Label, __assign({ subtitle: subtitle, tooltipText: isLimitOrder ? translations.confirmationMinDstAmountTootipLimit : translations.confirmationMinDstAmountTootipMarket }, { children: translations.minReceivedPerTrade })));
};
exports.OrderSummaryMinDstAmountOutLabel = OrderSummaryMinDstAmountOutLabel;
var OrdersLabel = function (_a) {
    var _b = _a.className, className = _b === void 0 ? "" : _b;
    var translations = (0, context_1.useTwapContext)().translations;
    return ((0, jsx_runtime_1.jsxs)(styles_1.StyledRowFlex, __assign({ justifyContent: "flex-start", style: { width: "auto" } }, { children: [(0, jsx_runtime_1.jsx)(base_1.Icon, { className: "stopwatch-icon", icon: (0, jsx_runtime_1.jsx)(AiOutlineHistory_1.AiOutlineHistory, { style: { width: 19, height: 19 } }) }), (0, jsx_runtime_1.jsx)(base_1.Label, __assign({ className: "twap-orders-title ".concat(className), tooltipText: translations.ordersTooltip, fontSize: 16 }, { children: translations.orders }))] })));
};
exports.OrdersLabel = OrdersLabel;
